<template>
    <div
        class="card"
        @click="openIntegrationPage"
    >
        <div
            class="card__container"
            v-if="!areIntegrationsUpdating"
        >
            <div class="header">
                <div
                    class="header__icon"
                    :style="{backgroundImage: `url(${integration.icon})`}"
                >
                </div>
                <div class="header__title">
                    {{ integration.title }}
                </div>
            </div>
            <div class="footer">
              <div class="footer-condition">
                <div class="footer-condition-package">
                <div class="footer-condition-package-text">Active:</div>
                <div class="footer-condition-package-number footer-condition-package-number_green">{{integration.active}}</div>
                </div>
                <div class="footer-condition-package">
                  <div class="footer-condition-package-text">Inactive:</div>
                  <div class="footer-condition-package-number">{{integration.inactive}}</div>
                </div>
              </div>
            </div>
        </div>
        <div
            class="card__container-loading"
            v-else
        >
        <div class="card__container-loading-row card__container-loading-row_small"></div>
        <div class="card__container-loading-row card__container-loading-row_big"></div>
        <div class="card__container-loading-row card__container-loading-row_big"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Card',
        props: {
            integration: {
                type: Object,
                required: true,
                default: () => ({}),
            },
            areIntegrationsUpdating: {
                type: Boolean,
                required: true,
                default: true,
            },
        },
        methods: {
            openIntegrationPage() {
                this.$emit('openIntegrationPage', this.integration.type);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .card {
        width: 350px;
        max-width: 350px;
        cursor: pointer;
        @include dark-shadow;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        margin: 10px;
        
        &__container {
            height: 100%;
            padding: 10px 20px 19px 16px;
            position: relative;
            
            &__status {
                position: absolute;
                right: 0;
                top: 0;
                background: $primary-color;
                width: 51px;
                height: 20px;
                color: #ffffff;
                border-radius: 0 10px 0 0;
                font-size: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            .header {
                display: flex;
                align-items: center;
                
                &__icon {
                    width: 40px;
                    height: 40px;
                    background-position: 0 0;
                    background-repeat: no-repeat;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                
                &__title {
                    padding-left: 13px;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 700;
                }
            }
            
            .content {
                padding: 13px 0;
                line-height: 18px;
                text-align: left;
                min-height: 75px;
            }
            
            .footer {
              margin-top: 15px;
                display: flex;
                align-items: flex-end;
                //justify-content: flex-end;
                height: 35px;
              &-condition {
                &-package {
                  display: flex;
                  &-text {
                    font: Quicksand ;
                    font-weight: Bold;
                    Size: 14px;
                    Line-height: 22px;
                    color: #3F3F40;
                  }
                  &-number {
                    margin-left: 5px;
                    font: Quicksand ;
                    font-weight: Bold;
                    Size: 14px;
                    Line-height: 22px;
                    color: #5E6C96;
                  }
                  &-number_green {
                    color: #00cd96;
                  }
                }

              }
            }
            
            &-loading {
                height: 104px;
                &-row {
                    height: 20px;
                    background: #E4ECFF;
                    border-radius: 2px;
                    margin: 10px;
                    
                    @include loading-animation;
                    
                    &_big {
                        width: calc(100% - 20px);
                    }
                    
                    &_small {
                        width: 100px;
                    }
                }
            }
        }
    }
</style>